var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Log_out_icon",
    "data-name": "Log out icon",
    d: "M301.44,590.78h-9a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3v-9A3,3,0,0,0,301.44,590.78ZM296.9,603.1h-2.86a1.41,1.41,0,0,1-1.04-.43,1.45,1.45,0,0,1-.42-1.04v-6.75a1.443,1.443,0,0,1,1.47-1.42h2.85a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-2.86a.468.468,0,0,0-.46.43v6.75a.444.444,0,0,0,.13.33.463.463,0,0,0,.32.13h2.87a.5.5,0,0,1,.5.5A.5.5,0,0,1,296.9,603.1Zm3.9-4.32h-4.35l.61.61a.5.5,0,0,1,0,.71.485.485,0,0,1-.35.15.507.507,0,0,1-.36-.15l-1.46-1.47a.456.456,0,0,1-.11-.16.5.5,0,0,1,0-.38.457.457,0,0,1,.11-.16l1.46-1.47a.5.5,0,0,1,.71.71l-.61.61h4.35a.5.5,0,0,1,0,1Z",
    transform: "translate(-289.44 -590.78)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSidebarIcon);
export default __webpack_public_path__ + "static/media/Logout-sidebar-icon.cb8ba6742f2b8813099a24ce2fc026f5.svg";
export { ForwardRef as ReactComponent };